import sanitizeHTMLSpecialChars from "@/utils/functions/sanitizeHTMLSpecialChars";
import testValidHTML from "@/utils/functions/testValidHTML";

interface Props {
  html: any;
}

const ProdDetails: React.FC<Props> = ({ html }) => {
  const isValidHTML = testValidHTML(html)  
  return isValidHTML ? (
    <div dangerouslySetInnerHTML={{__html:html}}/>
  ):<div>
{sanitizeHTMLSpecialChars(html)}
  </div>;
};

export default ProdDetails;
